export default function KeyAdvantages() {
  const advantages = [
    {
      imgSrc: "/assets/img/adv_new1.png",
      imgClass: "h-[40px] w-[29px]",
      title: "Discover with ease",
      description: "Compare Pre-qualified offers from  lenders",
    },
    {
      imgSrc: "/assets/img/adv_new2.png",
      imgClass: "h-[40px] w-[40px]",
      title: "Snag instant savings",
      description:
        "Select offers with lowest interest rates and processing",
    },
    {
      imgSrc: "/assets/img/adv_new3.png",
      imgClass: "h-[40px] w-[34px]",
      title: "Fast. Simple. Digital.",
      description:
        "4-step process to instant approval & transfer",
    },
    {
      imgSrc: "/assets/img/adv_new4.png",
      imgClass: "h-[37px] w-[44px]",
      title: "No Hidden Costs, Ever",
      description:
        "No hidden charges, no surprises—just honest information, always.",
    },
  ];

  return (
    <div className="w-full max-w-[400px] mx-auto px-4 py-6">
      <h2 className="text-[35px] font-bold text-center mb-2 font-bomstad-regular mt-4 ">Key Advantages</h2>
      <p className="text-center text-[18px] leading-[20px] text-[#006F59] ">
        We value your trust–Simple, fast, and reliable personal loans.
      </p>

      <div className="grid grid-cols-2 gap-3 font-atkinson mt-3">
        {advantages.map((adv, idx) => (
          <div
            key={idx}
            className="flex flex-col items-start border-[1.5px] border-[#CCF8E1] rounded-[30px] px-3 py-5 bg-white "
          >
            <img
              src={adv.imgSrc}
              alt={adv.title}
              className={`${adv.imgClass} mb-3`}
            />
            <h3 className="font-semibold text-[18px] leading-[1] mb-3 text-[#004739]">{adv.title}</h3>
            <p className="text-[14px] text-[#006F59] leading-[1]">{adv.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
